import React, { useEffect, useState } from 'react';
import CallsPanel from './CallsPanel';
import CallsAd from './CallsAd';
import { ApplicationApi } from '../../api/ApplicationApi';
import { useTenant } from '../../contexts/TenantContext';
import LoadingState from './LoadingState';

const Calls: React.FC = () => {
  const [isAcceptedTerms, setIsAcceptedTerms] = useState(false);
  const { tenant: { info } } = useTenant();
  const [isLoading, setIsLoading] = useState(true);

  const getTerms = async () => {
    try {
      const { response: terms } = await ApplicationApi.sendApplicationRequest(
        'getCallsTerms',
        info.id,
      );      

      if (terms?.resource && terms.resource.tenantId) {
        setIsAcceptedTerms(true);
      }

    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTerms();
  }, []);

  const page = isAcceptedTerms ? <CallsPanel /> : <CallsAd onSuccess={() => getTerms()} />;

  return (isLoading ? <LoadingState/> : page);
};

export default Calls;